import { useHistory, useRouteMatch } from 'react-router-dom';
import { REPORTING_BASE_PATH } from '../constants';
import { parseReportingTab } from '../functions';
import type { ReportingTabId } from '../interfaces';

export interface IUseReportingRouting {
  activeTab: ReportingTabId;
  handleTabChange: (tab: ReportingTabId) => void;
}

/** Syncs reporting active tab with React Router (/reporting/:tab). */
export const useReportingRouting = (): IUseReportingRouting => {
  const history = useHistory();
  const match = useRouteMatch<{ tab?: string }>(`${REPORTING_BASE_PATH}/:tab`);
  const activeTab = parseReportingTab(match?.params?.tab);

  const handleTabChange = (tab: ReportingTabId) => {
    history.push(`${REPORTING_BASE_PATH}/${tab}`);
  };

  return {
    activeTab,
    handleTabChange,
  };
};
